import React, {Component} from 'react';
import {connect} from 'react-redux';
import {  withRouter, NavLink } from 'react-router-dom';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { updateUser } from '../../../redux/actions/userAction';
import Select from '../../Helpers/react-select-all';
import 'react-select/dist/react-select.css';
import {Input} from 'reactstrap';

class ChildUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_profile: false,
            user_index: false,
            newUser: false,
            errorTexts : {
                name: false,
                telephone: false,
                email: false,
                password: false,
                password_repeat: false,
                selectedAddresses: false
            }
        }

        this.updateField = this.updateField.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

     updateEmail(e) {
        this.setState({
            user_email: e.target.value,
        });
    }



    updateField(e, isRequired, sameAs = false) {
        let errorTexts = this.state.errorTexts;

        if(isRequired) {
            if(e.target.value === '') {
                errorTexts[e.target.getAttribute('name')] = "Dit veld is verplicht";
            }else{
                errorTexts[e.target.getAttribute('name')] = false;
            }
        }

        if(sameAs !== false) {

            let thisField = e.target.value;
            let matchField = this.state.user_profile[sameAs];
            if(thisField && matchField) {

                if(e.target.value !== matchField) {
                     errorTexts[e.target.getAttribute('name')] = "Wachtwoorden zijn ongelijk";
                     errorTexts[sameAs] = "Wachtwoorden zijn ongelijk";
                }else{
                    errorTexts[e.target.getAttribute('name')] = false;
                    errorTexts[sameAs] = false;
                }
            }else{
                if(thisField === '' && matchField === '') {
                    errorTexts[e.target.getAttribute('name')] = false;
                    errorTexts[sameAs] = false;
                }else{
                     errorTexts[e.target.getAttribute('name')] = "Wachtwoorden zijn ongelijk";
                errorTexts[sameAs] = "Wachtwoorden zijn ongelijk";
                }

            }
        }

        this.setState({
            user_profile : {
                ...this.state.user_profile,
                [e.target.getAttribute('name')] : e.target.value
            },
            errorTexts
        })
    }

    handleSubmit(e) {
        if(e) {
            e.preventDefault();
        }

        const errors = this.state.errorTexts;
        let user_profile = this.state.user_profile;
        user_profile['user_id'] = this.state.user_id;
        let containsError = false;
        for (let key in errors) {
            if(errors.hasOwnProperty(key)) {
                if(errors[key] !== false) {
                    containsError = true;
                }
            }
        }


        if(!containsError) {
            if(!this.state.newUser) {
                this.props.updateUser(this.props.clientPath + '/api/user/action/update', user_profile, this.state.user_index, false, false, this.props.clientPath, this.props.user.user_id);
            }else{
                this.props.updateUser(this.props.clientPath + '/api/user/action/create', user_profile, false, this.props.user.user_id, false, this.props.clientPath, this.props.user.user_id);
            }
        }
    }

    UNSAFE_componentWillMount() {
        let stateToSet = {};
        if(this.props.match.params.id) {
            stateToSet = {
                ...this.state,
                user_profile: this.props.user.childUsers[this.props.match.params.id],
                user_id: this.props.user.childUsers[this.props.match.params.id]['user_id'],
                user_index: this.props.match.params.id
            };
        } else {
            stateToSet = {
                ...this.state,
                newUser: true
            };
        }


        if(this.props.addresses) {
            let addresses = [];
            for(let i = 0; i <= this.props.addresses.length; i++) {
                if(this.props.addresses[i]) {
                    let address = {
                        label: this.props.addresses[i]['street'],
                        value: this.props.addresses[i]['dp_address_id']
                    }

                    addresses.push(address);
                }
            }
            this.setState({
                ...stateToSet,
                addresses
            })

        }
    }

    handleSelectChange (value) {

        this.setState({
            ...this.state,
            user_profile: {
                ...this.state.user_profile,
                addresses: value,
                selectedAddresses:value
            }
        });
    }

    setCheckedValue(e) {
        this.setState({
            user_profile : {
                ...this.state.user_profile,
                [e.target.getAttribute('name')] : e.target.checked ? 1 : 0
            }
        })
    }

    componentDidMount() {
        document.querySelector('title').innerHTML = 'MijnDP - Gebruiker ' + (this.state.newUser ? 'aanmaken' : 'wijzigen');


        let input = document.querySelectorAll('.Select-input input');

        if ( input.length ) {
            input.forEach((item, i) => {
                item.setAttribute('autocomplete', false);
            });


        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.match.params.id) {
            if(prevProps.user.childUsers[this.props.match.params.id] != this.props.user.childUsers[this.props.match.params.id]) {
            let stateToSet = {
                ...this.state,
                user_profile: this.props.user.childUsers[this.props.match.params.id],
                user_id: this.props.user.childUsers[this.props.match.params.id]['user_id'],
                user_index: this.props.match.params.id
            };


            this.setState({stateToSet});
            }

        }
    }



    render() {
        let className  = '';

        if(!this.state.newUser) {
            className = "column--6";
        }

        return (
            <div className={className}>
                <div className="card">

                    <div className="card__header">
                      <h1>Gebruiker {this.state.newUser ? 'aanmaken' : 'wijzigen'}</h1>

                    </div>

                    <div className="card__body">
                        <div className="card__content">


                                    <form onSubmit={this.handleSubmit} autocomplete="off">
                                        <TextField
                                            id="name_childuser"
                                            name="name"
                                            floatingLabelText="Naam"
                                            errorText={this.state.errorTexts.name}
                                            fullWidth={true}
                                            required={true}
                                            value={this.state.user_profile ? this.state.user_profile.name : ''}
                                            onChange={(e) => this.updateField(e, true)}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    this.handleSubmit()
                                                }
                                              }}
                                        />

                                        <TextField
                                            id="telephone_childuser"
                                            floatingLabelText="Mobiel"
                                            name="telephone"
                                            fullWidth={true}

                                            errorText={this.state.errorTexts.telephone}
                                            value={this.state.user_profile ? this.state.user_profile.telephone : ''}
                                            onChange={(e) => this.updateField(e, false)}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    this.handleSubmit()
                                                }
                                              }}
                                        />

                                        <TextField
                                            id="email_childuser"
                                            name="email"

                                            floatingLabelText="E-mailadres"
                                            value={this.state.user_profile ? this.state.user_profile.email : ''}
                                            fullWidth={true}
                                            onChange={(e) => this.updateField(e, true)}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    this.handleSubmit()
                                                }
                                              }}
                                        />
                                        <div>
                                        <br />

                                        <Select
                                            closeOnSelect={true}
                                            disabled={false}
                                            multi={true}
                                            inputProps={
                                                [
                                                    {"autoComplete" : "off"}
                                                ]
                                            }
                                            autoComplete="off"
                                            onChange={this.handleSelectChange}
                                            options={this.state.addresses ? this.state.addresses : []}
                                            allowSelectAll={this.state.addresses ? this.state.addresses.length > 1 ? true : false : false}
                                            allOption={{label: 'Alle adressen', value: 'all'}}
                                            placeholder="Adressen"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            value={this.state.user_profile.selectedAddresses ? this.state.user_profile.selectedAddresses : false}

                                                        />
                                        </div>
                                        <React.Fragment>
                                        <span style={{fontSize: '12px', marginBottom : '-18px', display: 'block', marginTop: '15px'}}>Minimaal 7 tekens</span>
                                        <TextField
                                            id="password_childuser"
                                            name="password"
                                            type="password"
                                            autoComplete="off"

                                            errorText={this.state.errorTexts.password}
                                            floatingLabelText="Wachtwoord (minimaal 7 tekens)"
                                            fullWidth={true}
                                            onChange={(e) => this.updateField(e, (this.state.newUser ? true : false), 'password_repeat')}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    this.handleSubmit()
                                                }
                                              }}
                                        />
                                        <div>
                                        <TextField
                                            id="password_repeat_childuser"
                                            name="password_repeat"
                                            type="password"
                                            autoComplete="new-password"
                                            floatingLabelText="Wachtwoord herhalen"
                                            errorText={this.state.errorTexts.password_repeat}
                                            fullWidth={true}
                                            onChange={(e) => this.updateField(e, (this.state.newUser ? true : false), 'password')}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    this.handleSubmit()
                                                }
                                              }}
                                        />
                                        <br />
                                        </div>
                                        </React.Fragment>

                                        {Number(this.state.user_profile.is_active) === 1 ||  Number(this.state.user_profile.is_active) === 0 ?
                                        <div>
                                            <label style={{position: 'relative', top: '10px'}}>
                                                <Input value='1' defaultChecked={this.state.user_profile.is_active == '1' ? true : false} name="is_active" className="input__checkbox--search" type="checkbox"  onChange={(e) => this.setCheckedValue(e)}/>
                                                 Is actief?
                                            </label>
                                        </div> : ''}

                                        <label style={{position: 'relative', top: '10px'}}>
                                                <Input value='1'  defaultChecked={this.state.user_profile.mobile_verification == '0' ? false : true} name="mobile_verification" className="input__checkbox--search" type="checkbox"  onChange={(e) => this.setCheckedValue(e)}/>
                                                Inloggen met wachtwoord én SMS-verificatie code (extra veilig, maar 06 nummer is noodzakelijk). Als u deze optie niet kiest, kan uw subgebruiker inloggen met alleen het wachtwoord.
                                        </label>
                                        {/*this.props.user.user_profile.is_dps_user ?
                                        <label style={{position: 'relative', top: '10px'}}>
                                                <Input value='1'  defaultChecked={this.state.user_profile.is_dps_user == '0' ? false : true} name="is_dps_user" className="input__checkbox--search" type="checkbox"  onChange={(e) => this.setCheckedValue(e)}/>
                                                Is ook een DPS gebruiker?
                                        </label>
                                        : ''*/}

                                    </form>



                        </div>
                    </div>
                    <div className="card__footer card__footer--2-col">
                        <div className="card__footer__back-link">
                            { !this.state.newUser ? <NavLink to="/profiel" className="bottom__left__link">Terug naar instellingen</NavLink> : null }
                        </div>
                        <div className="card__footer__save-link">
                            <RaisedButton onClick={() => this.handleSubmit()} label="Opslaan" primary={true} fullWidth={true}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps (state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath,
        addresses: state.AddressReducer.addresses,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUser: (url, userData, childIndex, parentId, token, clientPath, fetchSubUserParentID) => dispatch(updateUser(url, userData, childIndex, parentId, token, clientPath, fetchSubUserParentID))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChildUserForm));



// WEBPACK FOOTER //
// ./src/components/User/ChildUserForm/index.js